import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { PublicHeader, PublicTabBar } from '@/components/PublicHeader';
import { BackHome } from '@/components/BackHome';
import { useT } from '@/i18n/context';
import { SandboxBanner } from '@/components/SandboxBanner';

/**
 * غلاف الصفحات العامة بلا دخول (الأدلة، التحقق، صفحة المؤسسة):
 * رأس بالعلامة يعيد إلى الصفحة الأولى، ومنطقة رئيسية، وتذييل — المعالم الأربعة لقارئ الشاشة.
 * يعيد استعمال أنماط الصفحة الرئيسية نفسها فلا لون ولا مقاس جديد.
 */
export function PublicLayout({ children, width = 960 }: { children: ReactNode; width?: number }) {
  const t = useT();
  return (
    <div className="landing" style={{ display: 'flex', flexDirection: 'column' }}>
      <a className="skip-link" href="#main">تخطَّ إلى المحتوى</a>
      <PublicHeader />
      <SandboxBanner />
      <main id="main" tabIndex={-1} className="stack gap-4" style={{ maxInlineSize: width, marginInline: 'auto', padding: 'var(--s-6)', inlineSize: '100%', flex: 1 }}>
        <BackHome />
        {children}
      </main>
      <footer className="ld-footer" style={{ paddingBlock: 'var(--s-6)' }}>
        <div className="wrap" style={{ gridTemplateColumns: '1fr' }}>
          <div className="legal" style={{ borderBlockStart: 0, paddingBlockStart: 0 }}>
            <span>{t('public.footer.rights', { year: new Date().getFullYear() })}</span>
            <span className="ld-footer__links">
              <Link to="/contact">تواصل معنا</Link>
              <Link to="/privacy">الخصوصية</Link>
              <Link to="/terms">شروط الاستخدام</Link>
              <Link to="/">{t('common.home')}</Link>
            </span>
          </div>
        </div>
      </footer>
      <PublicTabBar />
    </div>
  );
}
